import { RootSchema } from "../../../redux/reducers";
import { AnalyticsEvent } from "../types";
import { mapStaticMutation } from "./helpers";

const AUTH_STUDIO_TRACKED_EVENTS = [
  "auth_studio_template_created",
  "auth_studio_template_deployed",
  "auth_studio_template_edited",
  "auth_studio_language_changed",
  "auth_studio_cloned_style",
  "auth_studio_style_added_from_template"
] as const;

export const mapAuthStudioAnalyticsEvents = (previousState: RootSchema, currentState: RootSchema): AnalyticsEvent[] => [
  ...mapStaticMutation(previousState.hostedPages?.Brands, currentState.hostedPages?.Brands, {
    trackedEventNames: [...AUTH_STUDIO_TRACKED_EVENTS]
  }),
  ...mapStaticMutation(previousState.hostedPages?.CurrentBrand, currentState.hostedPages?.CurrentBrand, {
    trackedEventNames: [...AUTH_STUDIO_TRACKED_EVENTS]
  }),
  // Code tab saves (updatePage / updateV2Page) live on the Pages slice.
  ...mapStaticMutation(previousState.hostedPages?.Pages, currentState.hostedPages?.Pages, {
    trackedEventNames: ["auth_studio_template_edited"]
  })
];
